export default {
  mounted() {
    document.documentElement.style.overflow = "hidden"
    document.documentElement.style.height = "100%"
  },
  methods: {
    close() {
      document.documentElement.style.overflow = "scroll"
      this.$emit("update:isShown", false)
    }
  }
}
